import React, { useRef } from "react";
import PT from "prop-types";
import * as S from "./styled";
import { CircleButton, Button } from "_c/button";
import Tooltip from "_c/Tooltip";
import { CurrencyFormatter } from "@/i18n/currency";
import { useMut } from "@/hooks/useMut";
import { PremiumAPI } from "@/api/premium";
// import { useCtaAnimation } from "../hooks/useCtaAnimation";
import { openLinkInSameTab } from "@/utils";
import { analyticsAction } from "@/utils/analytics";
import { useLocale } from "@/hooks/useLocale";
import { AnimatePresence } from "framer-motion";
import { useAtom } from "jotai";
import { promocodeInputAtom } from "../atoms/promocode";

const PremiumPayment = ({
  t,
  price,
  initialPrice,
  isActive,
  isTrial,
  promocode,
  promocodeData,
  period,
  user,
}) => {
  const [input, setInput] = useAtom(promocodeInputAtom);
  const locale = useLocale();
  const promocodeLabel = t("premium:promocode");
  const promoDesc = promocodeData?.desc?.[locale];
  const promoIcon = promocodeData?.image;
  const paymentBtnRef = useRef(null);
  // useCtaAnimation(paymentBtnRef);
  const createPaymentMut = useMut(
    () =>
      PremiumAPI.createPayment({
        period,
        user,
        ...(promocode ? { promocode } : {}),
      }),
    {
      t,
      notifyOnError: true,
      onSuccess(data) {
        analyticsAction({
          action: "premium_payment",
          category: "Premium",
        });
        openLinkInSameTab(data.payment_url);
      },
    },
  );
  if (!price) return null;
  return (
    <S.Wrap>
      <strong style={{ fontSize: "16px", display: "block" }}>
        {t("premium:summary")}:
      </strong>
      {price.amount < initialPrice.amount && (
        <strike>{CurrencyFormatter.format(initialPrice)}</strike>
      )}
      <span>{CurrencyFormatter.format(price)}</span>
      <Tooltip title={t("premium:tooltip")}>
        <CircleButton
          type="button"
          style={{
            cursor: "help",
            marginTop: "7px",
          }}
          small
          light
        >
          ?
        </CircleButton>
      </Tooltip>
      <div
        css={`
          margin-top: 10px;
          position: relative;
          display: flex;
          align-items: center;
          button,
          input {
            flex-basis: 50%;
            flex-grow: 0;
          }
          .sub-cta-motion {
            pointer-events: none;
          }
        `}
        ref={paymentBtnRef}
      >
        <Button
          // css={`
          //   z-index: 3;
          // `}
          disabled={createPaymentMut.isLoading}
          // style={{ margin: "7px 0" }}
          type="button"
          onClick={createPaymentMut.mutate}
          greenish
          medium
        >
          {isActive && !isTrial
            ? t("premium:button_extend")
            : t("premium:button")}
        </Button>
        <S.PromocodeInput
          aria-label={promocodeLabel}
          placeholder={promocodeLabel}
          initial={false}
          animate={{
            backgroundColor: promocodeData ? "var(--color-cta)" : "#fff",
            color: promocodeData ? "#fff" : "#000",
          }}
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>
      <AnimatePresence initial={false}>
        {promocodeData && (
          <S.PromoInfoWrap
            initial={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {promoIcon && <S.Icon key="icon" layout src={promoIcon} />}
            {promoDesc && (
              <S.Desc key="desc" layout>
                {promoDesc}
              </S.Desc>
            )}
          </S.PromoInfoWrap>
        )}
      </AnimatePresence>
    </S.Wrap>
  );
};
PremiumPayment.propTypes = {
  isActive: PT.bool,
  isTrial: PT.bool,
  promocode: PT.string,
  price: PT.object,
  initialPrice: PT.object,
  period: PT.number,

  t: PT.func.isRequired,
};

export default PremiumPayment;
